import { useEffect, useState, useCallback } from "react";
import AppShell from "@/components/AppShell";
import { api } from "@/lib/api";
import { logger } from "@/lib/logger";
import { useAuth } from "@/context/AuthContext";
import { isStaff } from "@/lib/roles";
import DashboardStats from "@/components/dashboard/DashboardStats";
import TopMatches from "@/components/dashboard/TopMatches";
import BusinessSummary, { ProfileBanner } from "@/components/dashboard/BusinessSummary";
import VerificationBanner from "@/components/dashboard/VerificationBanner";
import StaffLanding from "@/components/dashboard/StaffLanding";

export default function Dashboard() {
  const { user } = useAuth();
  const staff = isStaff(user?.role);
  const [profile, setProfile] = useState(null);
  const [sub, setSub] = useState(null);
  const [matches, setMatches] = useState(null);

  const loadDashboard = useCallback(() => {
    if (staff) return;
    api.get("/profiles/me").then(({ data }) => setProfile(data)).catch(() => setProfile({}));
    api.get("/subscription").then(({ data }) => setSub(data)).catch((e) => logger.warn("load subscription", e));
    api.get("/matches").then(({ data }) => setMatches(data)).catch((e) => logger.warn("load matches", e));
  }, [staff]);

  useEffect(() => { loadDashboard(); }, [loadDashboard]);

  const hasProfile = Boolean(profile && profile.org_name);
  const planName = sub?.plan_detail?.display_name || sub?.plan_detail?.name || "Free";
  const isFree = sub?.effective_plan === "free";

  if (staff) {
    return (
      <AppShell title={`Welcome, ${user?.name?.split(" ")[0] || "there"}`} subtitle="Your staff workspace.">
        <StaffLanding role={user?.role} />
      </AppShell>
    );
  }

  return (
    <AppShell title={`Welcome, ${user?.name?.split(" ")[0] || "there"}`} subtitle="Here's your opportunity snapshot.">
      <VerificationBanner />
      {!hasProfile && profile !== null && <ProfileBanner />}
      <DashboardStats profile={profile} matches={matches} planName={planName} />
      <div className="mt-6 grid lg:grid-cols-3 gap-5">
        <TopMatches matches={matches} hasProfile={hasProfile} />
        <BusinessSummary profile={profile} isFree={isFree} />
      </div>
    </AppShell>
  );
}
